// React for Website

import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TbArrowBack } from "react-icons/tb";
//outsource
import { Row, Col, Button, Divider, Segmented } from "antd";

//components
import SectionSearch from "../../05_Voucher_Search/section_search";
import SectionReport from "../../05_Voucher_Report/section_report";
import SectionDetail from "../../05_Voucher_Detail/section_detail";
import { VOUCHER_SUB } from "../../../store/string";

const VoucherEdit = () => {
  // -------------------------- VAR --------------------------
  const navigate = useNavigate();
  const params = useParams();
  const id = params?.id || "";
  // -------------------------- STATE --------------------------
  const [section, setSection] = useState("detail");
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  const onChange = (values) => {
    console.log("values", values);
    setSection(values);
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const renderTitle = () => {
    return (
      <Row>
        <Col lg={12} md={12} sm={24} xs={24}>
          <b style={{ fontSize: 18 }}>Edit Voucher</b>
        </Col>
        <Col align="right" lg={12} md={12} sm={24} xs={24}>
          {renderButtonGroup()}
        </Col>
      </Row>
    );
  };

  const renderButtonGroup = () => {
    return (
      <Row justify="end" gutter={[10, 10]}>
        <Col>
          <Button
            onClick={() => navigate(`/branchs/detail/${id}/voucher`)}
            // style={{ width: 120 }}
            icon={
              <span className="anticon">
                <TbArrowBack />
              </span>
            }
            type="link"
          >
            Campaign List
          </Button>
        </Col>
      </Row>
    );
  };

  const renderSegmented = () => {
    return (
      <Col lg={24} md={24} sm={24} xs={24}>
        <Segmented
          defaultValue="detail"
          size="medium"
          options={VOUCHER_SUB}
          onChange={onChange}
        />
      </Col>
    );
  };

  const renderSection = () => {
    if (section === "search") {
      return <SectionSearch />;
    } else if (section === "report") {
      return <SectionReport />;
    } else {
      return <SectionDetail />;
    }
  };

  // -------------------------- MAIN --------------------------
  return (
    <Row id="voucher-add">
      <Col lg={24} md={24} sm={24} xs={24}>
        {renderTitle()}
      </Col>
      <Divider />
      <Col lg={24} md={24} sm={24} xs={24}>
        {renderSegmented()}
      </Col>
      <Col style={{ marginTop: 20 }} lg={24} md={24} sm={24} xs={24}>
        {renderSection()}
      </Col>
    </Row>
  );
};

export default VoucherEdit;
